import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ text, speed = 40, dark = false }) {
  const items = Array.isArray(text) ? text : [text];
  return (
    <div
      className={`overflow-hidden border-y ${
        dark ? "border-white/15 bg-black text-white" : "border-black bg-white text-black"
      } py-5`}
    >
      <Marquee speed={speed} gradient={false}>
        {items.map((t, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 font-heading text-3xl font-extrabold uppercase tracking-tight md:text-5xl">
            {t}
            <span className="text-gavra">✳</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
